import { Loader2 } from 'lucide-react';
import { toast } from 'sonner';

import { useAddStudentToWaitlistMutation } from '~entities/classes/api/wait-list/add-student-to-waitlist';

import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '~shared/shadcn/ui/alert-dialog';
import { Button } from '~shared/shadcn/ui/button';

interface AddStudentToWaitlistProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  classId: string;
  studentId: string;
}

export const AddStudentToWaitlist = ({
  isOpen,
  setIsOpen,
  classId,
  studentId,
}: AddStudentToWaitlistProps) => {
  const { mutateAsync: addStudentToWaitlist, isPending } =
    useAddStudentToWaitlistMutation();

  const handleAddStudentToWaitlist = async () => {
    try {
      await addStudentToWaitlist({
        classId,
        studentId,
        priority: 'normal',
        notes: '',
      });
      setIsOpen(false);
      toast.success('Student added to waitlist');
    } catch (error) {
      console.error(error);
      toast.error('Failed to add student to waitlist');
    }
  };

  return (
    <AlertDialog open={isOpen} onOpenChange={setIsOpen}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Add Student to Waitlist</AlertDialogTitle>
          <AlertDialogDescription>
            Add a student to the waitlist for this class.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <Button onClick={handleAddStudentToWaitlist} disabled={isPending}>
            {isPending && <Loader2 className='animate-spin' />} Continue
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
